'use client';

import { useAtomValue } from 'jotai';
import Script from 'next/script';

import type { Tenant } from '@core/Entities/App/Tenants.entity';
import { hasSetCookiesAtom } from '@tracking/Atoms/HasSetCookies.atom';

import { ENCORE_SCRIPT_MAP } from './EncoreScriptMap';

type Props = {
  tenant?: Tenant;
};

export const EncoreScript = ({ tenant }: Props) => {
  const hasSetCookies = useAtomValue(hasSetCookiesAtom);

  const clientId = tenant ? ENCORE_SCRIPT_MAP[tenant] : ENCORE_SCRIPT_MAP.heycar;

  if (!hasSetCookies) return null;

  return (
    <>
      <link rel="dns-prefetch" href="https://tags.crwdcntrl.net" />
      <link rel="dns-prefetch" href="https://bcp.crwdcntrl.net" />
      <link rel="dns-prefetch" href="https://c.ltmsphrcl.net" />

      <Script id="encore-script" type="text/javascript">
        {`! function() {
      var lotameClientId = '${clientId}';
      var lotameTagInput = {
          data: {},
          config: {
            clientId: Number(lotameClientId)
          }
      };
      // Lotame initialization
      var lotameConfig = lotameTagInput.config || {};
      var namespace = window['lotame_' + lotameConfig.clientId] = {};
      namespace.config = lotameConfig;
      namespace.data = lotameTagInput.data || {};
      namespace.cmd = namespace.cmd || [];
    } ();`}
      </Script>
      <Script
        id="lotame-lightning-tag"
        async
        src={`https://tags.crwdcntrl.net/lt/c/${clientId}/lt.min.js`}
      ></Script>
    </>
  );
};

EncoreScript.displayName = 'EncoreScript';
